import { Component, Vue } from 'vue-property-decorator';

import BookService from '@/services/Book/BookService';

import { Book as IBook } from '@/globalInterfaces/Book';

interface Search {
  content: string;
  type: string;
  context: string;
  bookId: number;
  bookTitle: string;
  workspace: string;
  topicId: number;
  topicTitle: string;
  bigtext: string;
  bookSlug: string;
  contentSlug: string;
  topicSlug: string;
  url?: string;
  details: {
    type: string;
    id: number;
  };
}

@Component
export default class SearchBook extends Vue {
  protected searchList: Array<Search> = [];
  protected searchNotFound = '';

  protected BookService = new BookService();

  async onSearchChange(searchValue: string, idBook?: number) {
    this.searchNotFound = '';
    this.searchList = [];

    if (searchValue.length) {
      const response = await this.BookService.getSearch(searchValue, idBook);

      if (!response || !response.length) {
        this.searchNotFound = `${String(this.$t('mixins.searchBook.searchNotFound'))} '${searchValue}'`;
        return;
      }

      const newListSearch: Array<Search> = [];

      response.forEach((item: Search) => {
        newListSearch.push({
          ...item,
          content: `${item?.bookTitle} - ${item?.topicTitle}: ${item?.content}`
        });
      });

      this.searchList = newListSearch;
    }
  }

  async searchLink(item: Search) {
    if (item?.bookId) {
      const topicID = item.topicId;
      const fileID = item.details.id;
      const itemUrl = item.url;
      const itemContentSlug = item.contentSlug;
      const slugBook = item.bookSlug;
      
      let slugFile = item.content
        .toLowerCase()
        .split(' ')
        .join('-');

      slugFile = this.removeAccents(slugFile);

      if (item.details.type === 'archives' && itemUrl) {
        this.downloadArchive(itemUrl, itemContentSlug);       
        return;
      }

      if (item.details.type === 'videos') {
        this.$router.push({ path: `/videos/caderno/${slugBook}/${topicID}/${fileID}/${slugFile}` });
        return;
      }

      if (item.details.type === 'exercices') {
        this.$router.push({
          path: `/exercicios/caderno/${slugBook}/${topicID}/${fileID}/${slugFile}`
        });
      }
    }
  }

  removeAccents(slugFile: string) {
    const slugFileAccents = slugFile.split('');
    const slugFileAccentsOut: string[] = [];
    const slugFileAccentsLength = slugFileAccents.length;
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';

    for (let y = 0; y < slugFileAccentsLength; y += 1) {
      const index = accents.indexOf(slugFileAccents[y]);

      slugFileAccentsOut[y] = index !== -1 ? accentsOut[index] : slugFileAccents[y];
    }

    return slugFileAccentsOut.join('');
  }

  downloadArchive(url: string, title: string) {
    const a = document.createElement('a') as HTMLAnchorElement;

    a.href = `https://explicae.com.br/app/${url}`;

    a.download = title;

    a.target = '_blank';

    (document.body || document.documentElement).appendChild(a);
    a.click();
    // @ts-ignore
    a.parentNode.removeChild(a);
  }
}
